import { useCmmdRuntimeInventorySnapshot } from "../../cmmd/cmmdRuntimeInventoryResource";
import { classifyEnvironmentId } from "../../environments/environmentIdClassification";
import { useSavedEnvironmentRegistryStore } from "../../environments/runtime/catalog";
import { resolveSavedDraftBreadcrumb, resolveSavedThreadBreadcrumb } from "./savedThreadBreadcrumb";
import type { ThreadRouteTarget } from "../../threadRoutes";
import { useCmmdForgeRuntimeListSnapshot } from "../../cmmd/cmmdForgeRuntimeListResource";
import { findCloudRowForEnvironment } from "../../routes/cloudRouteCatalogRow";
import type { EnvironmentId } from "@cmmd-forge/contracts";

export function useSavedThreadBreadcrumb(
  routeTarget: ThreadRouteTarget | null,
  draftProjectRef: { readonly environmentId: string; readonly projectId: string } | null = null,
) {
  const inventory = useCmmdRuntimeInventorySnapshot();
  const catalog = useCmmdForgeRuntimeListSnapshot();
  const routeThreadRef = routeTarget?.kind === "server" ? routeTarget.threadRef : null;
  const routeEnvironmentId = routeThreadRef?.environmentId ?? draftProjectRef?.environmentId;
  const registeredRuntimeId = useSavedEnvironmentRegistryStore((state) =>
    routeEnvironmentId === undefined
      ? null
      : (state.byId[routeEnvironmentId as EnvironmentId]?.runtimeId ?? null),
  );
  const cloudRow = findCloudRowForEnvironment(routeEnvironmentId, catalog.rows, []);
  const runtimeId =
    cloudRow?.runtimeId ??
    registeredRuntimeId ??
    classifyEnvironmentId(routeEnvironmentId).legacyRuntimeId;
  const savedIdentity = routeThreadRef
    ? resolveSavedThreadBreadcrumb(
        inventory.inventory?.runtimes ?? [],
        runtimeId,
        routeThreadRef.threadId,
      )
    : resolveSavedDraftBreadcrumb(
        inventory.inventory?.runtimes ?? [],
        runtimeId,
        draftProjectRef?.projectId ?? null,
      );
  const savedProjectRef =
    savedIdentity && routeThreadRef
      ? { environmentId: routeThreadRef.environmentId, projectId: savedIdentity.projectId }
      : null;
  return { savedIdentity, savedProjectRef };
}
